export default "__VITE_ASSET__C$IZuV1O__"